import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useEmpresa } from "./context/EmpresaContext"

export const RequirePasswordUpdated = () => {
  const { me, loading } = useEmpresa()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 text-sm text-slate-600">
        Carregando…
      </div>
    )
  }

  if (me?.must_change_password && location.pathname !== "/app/alterar-senha") {
    return <Navigate to="/app/alterar-senha" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
